import type CursorStyles from './types';

const cursor: CursorStyles = {
    cursorDefault: {
        cursor: 'default',
    },
    cursorDisabled: {
        cursor: 'not-allowed',
    },
    cursorPointer: {
        cursor: 'pointer',
    },
    cursorMove: {
        cursor: 'move',
    },
    cursorUnset: {
        cursor: 'unset',
    },
    cursorAuto: {
        cursor: 'auto',
    },
    cursorZoomIn: {
        cursor: 'zoom-in',
    },
    cursorGrabbing: {
        cursor: 'grabbing',
    },
    cursorZoomOut: {
        cursor: 'zoom-out',
    },
    cursorInitial: {
        cursor: 'initial',
    },
    cursorText: {
        cursor: 'text',
    },
};

export default cursor;
